/**
 * Clave de consulta de "Mi horario" (008 · T095; contracts/staff-api.md S1, research R-26).
 *
 * Vive en su propio módulo (sin dependencias), como `regularization/keys.ts`, para que
 * `features/history/api.ts` (`invalidateAttendanceViews`) la importe sin ciclos. `./api.ts` la
 * reexporta: el nombre público es `STAFF_DAYS_QUERY_KEY` de `features/schedule/api.ts`.
 */
export const STAFF_DAYS_QUERY_KEY = ['staff-days'] as const;
